import React from 'react'
import qs from 'qs'
import { ProductBadge, Divider } from '@yanolja-rnd/nol-design-system'
import { DomesticCartTrainItem } from '~/api/converters/domestic/cart/ProductSection/Train/index.type'
import TrainOption from './option'
import { getYaNative } from '@yanolja-rnd/ya-native'
import { isNative } from '~/app/utils/typeguards'

interface TrainItemProps {
  item: DomesticCartTrainItem
}

const TrainItem: React.FC<TrainItemProps> = ({ item }) => {
  const { itemTitle, options, isRoundTrip } = item

  /** 구매 가능한 옵션이 하나라도 있는지 확인 */
  const hasAvailableOption = options.some(option => option.isSaleAvailable)

  const onTitleClick = () => {
    const { href, searchParams } = new URL(item.linkUrl)

    const yaNative = getYaNative()
    isNative(yaNative)
      ? yaNative.wv({ url: href, params: qs.parse(searchParams.toString()) })
      : (location.href = href)
  }

  return (
    <div className="rounded-16 bg-static-white p-16 pc:p-24">
      {/* 그룹 헤더 */}
      <div className="pb-16">
        {/* 기차 Badge */}
        <ProductBadge type="filled_secondary" size="medium" className="mb-6 px-6 py-2">
          교통
        </ProductBadge>

        {/* 타이틀 */}
        <div
          className="cursor-pointer typography-subtitle-18-bold"
          role="button"
          tabIndex={0}
          aria-label="기차 검색 페이지로 이동"
          onClick={onTitleClick}
        >
          {itemTitle}
        </div>
      </div>
      <Divider size="small" type="horizontal" className="mb-20" />

      {/* 옵션 목록 */}
      <div className="flex flex-col gap-40">
        {options.map((option, index) => (
          <TrainOption
            key={index}
            option={option}
            showCheckbox={index === 0 || !isRoundTrip}
            linkUrl={item.linkUrl}
          />
        ))}
      </div>

      {/* 구매 가능한 옵션이 있을 때만 안내 문구 노출 */}
      {hasAvailableOption && (
        <div className="mt-20 text-center typography-body-12-regular">
          기차는 국내숙소와 함께 구매 가능해요.
        </div>
      )}
    </div>
  )
}

export default TrainItem
